import InvalidEmailMessage from './InvalidEmailMessage';

export default InvalidEmailMessage;
